import Button from "components/Button";
import Modal from "components/Modal";
import { ExclamationSVGIcon } from "components/SVGIcons";
import styles from "./style.module.scss";
import { mdiLoading } from "@mdi/js";
import Icon from "@mdi/react";

interface IProps {
  title?: string;
  content: string | React.ReactNode;
  isConfirmModalOpen: boolean;
  toggleConfirmModal: VoidFunction;
  onOK?: VoidFunction;
  onCancel?: VoidFunction;
  labelOKButton?: string;
  labelCancelButton?: string;
  isHideHeaderIcon?: boolean;
  isHideOKButton?: boolean;
  isHideCancelButton?: boolean;
  isLoading?: boolean;
}

export default function ConfirmationModal({
  title = "Confirm",
  content,
  isConfirmModalOpen,
  toggleConfirmModal,
  onOK,
  onCancel,
  labelOKButton = "OK",
  labelCancelButton = "Cancel",
  isHideHeaderIcon = false,
  isHideCancelButton = false,
  isHideOKButton = false,
  isLoading = false
}: Readonly<IProps>) {
  return (
    <Modal
      isOpen={isConfirmModalOpen}
      closeModal={toggleConfirmModal}
      wrapperClass="!my-auto text-sm desktop:text-lg"
      dialogClass="!bg-modalBg !px-5 !py-5 !border !border-card !overflow-y-auto gap-4 desktop:!px-8 desktop:!py-10"
      closeClass="!top-24 desktop:!top-28 !right-6 desktop:!right-12 !bg-transparent !text-placeholder">
      <div className={styles.confirmationModalHeader}>
        {!isHideHeaderIcon && <ExclamationSVGIcon height={50} width={50} />}
        <p className="pt-1.5 font-medium whitespace-pre-wrap">{title}</p>
      </div>
      <p className="pt-1.5 font-medium whitespace-pre-wrap">{content}</p>
      <div className={styles.footer}>
        {!isHideCancelButton && (
          <Button onClick={onCancel ?? toggleConfirmModal} rounded variant="outline">
            {labelCancelButton}
          </Button>
        )}
        {!isHideOKButton && (
          <Button disabled={isLoading} onClick={onOK ?? toggleConfirmModal} rounded>
            {isLoading ? <Icon path={mdiLoading} size={1} spin={1} /> : labelOKButton}
          </Button>
        )}
      </div>
    </Modal>
  );
}
